import { render, staticRenderFns } from "./FullTerm.vue?vue&type=template&id=b5a85324&scoped=true"
import script from "./FullTerm.vue?vue&type=script&lang=js"
export * from "./FullTerm.vue?vue&type=script&lang=js"
import style0 from "./FullTerm.vue?vue&type=style&index=0&id=b5a85324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a85324",
  null
  
)

export default component.exports